'use strict';

var shortdate = require('shortdate');

module.exports = function (pattern, names) {
    check(pattern, names);
    
    return names.map(parse(pattern));
};

var parse = function (pattern) { return function (full, i) {
    var ref = splitName(full);
    var name = ref[0];
    var ext = ref[1];
    var date = shortdate(new Date(), {
        sep: '-',
    });
    
    return pattern
        .replace('[n]', name)
        .replace('[e]', ext)
        .replace('[c]', i + 1)
        .replace('[ymd]', date);
}; };

function splitName(str) {
    var index = str.lastIndexOf('.');
    
    if (!~index)
        { return [
            str,
            '' ]; }
    
    return [
        str.substr(0, index),
        str.substr(index) ];
}

function check(pattern, names) {
    if (!pattern)
        { throw Error('pattern could not be empty!'); }
    
    if (!Array.isArray(names))
        { throw Error('names should be an array!'); }
}

